import type { LockState } from "../api/types";
import { stateColor, stateTitle } from "../lib/lockcard";

/**
 * Замок исхода — значком.
 *
 * Дужка ЗАМКНУТА, когда исход определён, и приоткрыта, пока его ещё можно
 * перевернуть. Это не украшение: состояние читается формой раньше, чем цветом,
 * и раньше, чем текстом, — а на цвет полагаться нельзя, часть операторов его не
 * различает.
 *
 * Живёт отдельным файлом, потому что делят его ДВЕ панели: сквозная полоса
 * карточек (components/LockAlerts.tsx) и ярус замка в карточке рынка
 * (components/IndexCheck.tsx). Один значок на оба места — обязательное условие:
 * два разных для одного состояния означали бы, что оператор переучивается при
 * переводе взгляда.
 */
export function LockGlyph({ state, label }: { state: LockState; label: string }) {
  const shut = state === "settled";
  return (
    <svg
      viewBox="0 0 24 24"
      width="14"
      height="14"
      className="shrink-0"
      style={{ color: stateColor(state) }}
      role="img"
    >
      {/* Имя значка — формулировка СЕРВЕРА: она объясняет, почему состояние
          такое. Пусто она бывает у старого трейдера, и тогда значок называет
          хотя бы состояние: безымянная картинка для чтения с экрана — пустота. */}
      <title>{label || stateTitle(state)}</title>
      <path
        d={shut ? "M8 10.5V7.5a4 4 0 0 1 8 0v3" : "M8 10.5V7.5a4 4 0 0 1 7.4-2"}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
      <rect x="4.5" y="10.5" width="15" height="10" rx="2" fill="currentColor" />
      <circle cx="12" cy="15.5" r="1.6" fill="var(--color-panel)" />
    </svg>
  );
}
